import { HazardousObject, HazardousObjectTier } from "../types/api.types";

// Backend defaults. They differ per tier on purpose.
export const DEFAULT_UPPER_TIER_RADIUS = 20000;
export const DEFAULT_LOWER_TIER_RADIUS = 5000;

export const formatDistanceFromMeters = (meters: number) => {
  if (meters < 1000) return `${meters} m`;
  return `${(meters / 1000).toFixed(1).replace(".0", "").replace(".", ",")} km`;
};

export const HazardousObjectTierLabels: Record<HazardousObjectTier, string> = {
  [HazardousObjectTier.Upper]: "Aukštesniojo lygmens objektas",
  [HazardousObjectTier.Lower]: "Žemesniojo lygmens objektas",
};

/**
 * The tiers say how much dangerous substance an object holds, not how dangerous it is,
 * and they are searched over different radiuses, so the caption has to spell that out.
 * It sits on the section, not on every object, because it is the same for all of them.
 */
export const getHazardousObjectsSearchDescription = () =>
  `Aukštesniojo lygmens objektuose laikoma daugiau pavojingų medžiagų, jie tikrinami dažniau, o teritoriją už jų ribų apima savivaldybės ekstremaliųjų situacijų planas, todėl jų ieškota iki ${formatDistanceFromMeters(
    DEFAULT_UPPER_TIER_RADIUS
  )} nuo turto, o žemesniojo lygmens – iki ${formatDistanceFromMeters(
    DEFAULT_LOWER_TIER_RADIUS
  )}. Dėl to abiejų lygmenų teritorija apieškota nevienodai. Lygmuo nurodo laikomų pavojingų medžiagų kiekį, o ne pavojingumą, todėl lygmenys tarpusavyje nepalyginami. Teisiškai nustatyto poveikio spindulio nėra – poveikio zonos modeliuojamos kiekvienam objektui atskirai. Duomenų šaltinis – pagd.lrv.lt.`;

export const getHazardousObjectCaption = (hazardousObject: HazardousObject) =>
  [hazardousObject.company, hazardousObject.address]
    .filter(Boolean)
    .join(" · ");
